// extracted by mini-css-extract-plugin
export var displayNone = "_rr-6";
export var imgContainer = "_rr-2";
export var overflowHidden = "_rr-3";
export var productInfoCardButtonContainer = "_rr-5";
export var productTitleText = "_rr-4";
export var rightArrow = "_rr-1";
export var rightArrowContainer = "_rr-0";